/**
 * Ensure chat HTML report `srcDoc` documents stay readable in light and dark UI themes.
 * Model-generated HTML often assumes a light page (black text); the iframe surface in dark
 * mode otherwise leaves black-on-dark content.
 */
export function themeHtmlReportDocument(html: string, darkMode: boolean): string {
  const raw = (html || "").trim();
  if (!raw) return raw;

  const themeCss = darkMode
    ? [
        "html,body{background:#1a1d23;color:#e8eaed;}",
        "a{color:#90caf9;}",
        "h1,h2,h3,h4,h5,h6,strong,b{color:#f5f5f5;}",
        "hr{border-color:rgba(255,255,255,0.2);}",
        "code,pre{background:#2a2f3a;color:#e8eaed;}",
        "table{border-color:rgba(255,255,255,0.2);}",
        "th,td{border-color:rgba(255,255,255,0.2);color:inherit;}",
        "th{background:rgba(255,255,255,0.08);}",
      ].join("")
    : [
        "html,body{background:#ffffff;color:#1a1a1a;}",
        "a{color:#1565c0;}",
      ].join("");

  const injected =
    `<style data-gar-chat-html-theme="1">` +
    `${themeCss}` +
    `body{margin:12px;font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;line-height:1.5;}` +
    `</style>`;

  if (/data-gar-chat-html-theme/i.test(raw)) return raw;

  if (/<head[\s>]/i.test(raw)) {
    return raw.replace(/<head([^>]*)>/i, `<head$1>${injected}`);
  }
  if (/<html[\s>]/i.test(raw)) {
    return raw.replace(/<html([^>]*)>/i, `<html$1><head>${injected}</head>`);
  }
  if (/<!doctype/i.test(raw)) {
    return raw.replace(/(<!doctype[^>]*>)/i, `$1<html><head>${injected}</head><body>`) + "</body></html>";
  }
  return `<!DOCTYPE html><html><head>${injected}</head><body>${raw}</body></html>`;
}
